<template>
  <div class="container">
    <ttsps-auth-alert show-logged-in/>

    <main>
      <sl-alert open>
        <sl-icon slot="icon" name="info-circle"></sl-icon>
        <div>A bundle is a release artifact.</div>
        <div>A release contains <code>n</code> bundles. </div>
        <div>The last approved bundle for a release is the recommended version to use.</div>
        <div>A bundle contains n components in a given version.</div>
        <div>A component is a software component, such as the producer or the curator.</div>
      </sl-alert>

      <div class="card-container">
        <sl-card class="show">
          <div class="content">
            <sl-icon name="eye"></sl-icon>
            <div class="title">Show</div>
            <div class="description">
              <div>Show approved Bundles</div>
            </div>
          </div>
          <div class="footer" slot="footer">
            <sl-button variant="primary" href="./approved-bundles.html">Approved Bundles</sl-button>
            <sl-button class="hidden" variant="primary">noop</sl-button>
          </div>
        </sl-card>

        <sl-card class="find">
          <div class="content">
            <sl-icon name="search"></sl-icon>
            <div class="title">Find</div>
            <div class="description">
              <div>Find stuff like (unreleased) components.</div>
            </div>
          </div>
          <div class="footer" slot="footer">
            <sl-button variant="primary" href="./components-overview.html">Components Overview</sl-button>
            <sl-button variant="primary" href="./graphiql.html">API-Explorer (Graphiql)</sl-button>
          </div>
        </sl-card>

        <sl-card class="create">
          <div class="content">
            <sl-icon name="plus-square"></sl-icon>
            <div class="title">Create & Approve</div>
            <div class="description">
              <div>Create new release related artifacts like bundles</div>
            </div>
          </div>
          <div class="footer" slot="footer">
            <sl-button variant="primary" href="./approval.html">Approve Release Bundle</sl-button>
            <sl-button variant="primary" href="./create-release-bundle.html">Create Release Bundle</sl-button>
          </div>
        </sl-card>

        <sl-card class="custom">
          <div class="content">
            <sl-icon name="magic"></sl-icon>
            <div class="title">Custom</div>
            <div class="description">
              <div>Custom stuff which is not standard</div>
            </div>
          </div>
          <div class="footer" slot="footer">
            <sl-button variant="primary" href="./package-creator-templates.html">Package Creator Templates</sl-button>
            <sl-button variant="primary" href="https://template-option-builder.tts.dev">Templates Option Builder</sl-button>
          </div>
        </sl-card>

        <sl-card class="customerQA">
          <div class="content">
            <sl-icon name="hammer"></sl-icon>
            <div class="title">Customer QA Build</div>
            <div class="description">
              <div>Customer QA builds</div>
            </div>
          </div>
          <div class="footer" slot="footer">
            <sl-button variant="primary" href="./create-qa-customer-build.html">Create QA Customer Build</sl-button>
            <sl-button variant="primary" href="./list-qa-customer-build.html">List QA Customer Builds</sl-button>
          </div>
        </sl-card>
      </div>
    </main>
  </div>
</template>

<style scoped>

.container {
  display: flex;
  flex-direction: column;
  gap: var(--sl-spacing-medium);
  padding: var(--sl-spacing-medium);
}


.card-container {
  margin-top: 16px;

  & sl-card.show {
    --sl-color-primary-50: #f0fdf4;
    --sl-color-primary-100: #dcfce7;
    --sl-color-primary-200: #bbf7d0;
    --sl-color-primary-300: #86efac;
    --sl-color-primary-400: #4ade80;
    --sl-color-primary-500: #22c55e;
    --sl-color-primary-600: #16a34a;
    --sl-color-primary-700: #15803d;
    --sl-color-primary-800: #166534;
    --sl-color-primary-900: #14532d;
  }

  & sl-card.create {
  }

  & sl-card.custom {
    --sl-color-primary-50: #fff7ed;
    --sl-color-primary-100: #ffedd5;
    --sl-color-primary-200: #fed7aa;
    --sl-color-primary-300: #fdba74;
    --sl-color-primary-400: #fb923c;
    --sl-color-primary-500: #f97316;
    --sl-color-primary-600: #ea580c;
    --sl-color-primary-700: #c2410c;
    --sl-color-primary-800: #9a3412;
    --sl-color-primary-900: #7c2d12;
  }

  & sl-card.find {
    --sl-color-primary-50: #f0fdfa;
    --sl-color-primary-100: #ccfbf1;
    --sl-color-primary-200: #99f6e4;
    --sl-color-primary-300: #5eead4;
    --sl-color-primary-400: #2dd4bf;
    --sl-color-primary-500: #14b8a6;
    --sl-color-primary-600: #0d9488;
    --sl-color-primary-700: #0f766e;
    --sl-color-primary-800: #115e59;
    --sl-color-primary-900: #134e4a;
  }

  & sl-card.customerQA {
    //display: none;
    --sl-color-primary-50: oklch(97.7% 0.017 320.058);
    --sl-color-primary-100: oklch(95.2% 0.037 318.852);
    --sl-color-primary-200: oklch(90.3% 0.076 319.62);
    --sl-color-primary-300: oklch(83.3% 0.145 321.434);
    --sl-color-primary-400: oklch(74% 0.238 322.16);
    --sl-color-primary-500: oklch(66.7% 0.295 322.15);
    --sl-color-primary-600: oklch(59.1% 0.293 322.896);
    --sl-color-primary-700: oklch(51.8% 0.253 323.949);
    --sl-color-primary-800: oklch(45.2% 0.211 324.591);
    --sl-color-primary-900: oklch(40.1% 0.17 325.612);
    --sl-color-primary-950: oklch(29.3% 0.136 325.661);
  }

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: var(--sl-spacing-medium);

  & sl-card{
    &::part(footer){
      display: grid;
      grid-template-rows: subgrid;
      grid-row: 2/3;
    }

    & .content {
      display: grid;
      grid-template-rows: auto auto;
      grid-template-columns: auto 1fr;
      grid-template-areas:
        "icon title"
        "description description";
      gap: var(--sl-spacing-medium);
      --header-size: 2rem;

      & .title {
        grid-area: title;
        font-size: var( --header-size);
      }

      & .description {
        grid-area: description;
        padding-left: 8px;
        font-size: 0.75rem;
        font-style: italic;
        line-height: 1.5rem;
      }

      & sl-icon {
        grid-area: icon;
        color: var(--sl-color-primary-300);
        font-size: var( --header-size);
      }
    }

    & .footer {
      display: grid;
      grid-row: 2/3;
      grid-template-columns: 1fr min-content;
      row-gap: 24px;

      & > * {
        grid-column: 2/-1;
      }
    }

  }

  .hidden {
    visibility: hidden;
  }
}

</style>

<script setup>
import TtspsAuthAlert from "./components/ttsps-auth-alert.vue";
</script>
